const INITIAL_STATE = {
  data: {},
  InvoiceCreditMemoList:{},
  errors: {},
}
  
const getInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_ACCOUNT_LISTING_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_ACCOUNT_LISTING_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_INVOICE_CREDIT_MEMO_LIST':
    return { ...state, ...INITIAL_STATE, InvoiceCreditMemoList: action.data }
  case 'GET_INVOICE_CREDIT_MEMO_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getInvoice;